import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { api } from '../contexts/AuthContext';

const PaymentReturnPage = () => {
  const navigate = useNavigate();
  const [state, setState] = useState('checking'); // checking | success | failed

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pid = params.get('payment_intent');
    if (!pid) {
      setState('failed');
      return;
    }
    let attempts = 0;
    let timer;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/payments/intent-status/${pid}`);
        if (res.data.payment_status === 'paid') {
          setState('success');
          return;
        }
        if (res.data.payment_status === 'failed') {
          setState('failed');
          return;
        }
      } catch (e) {
        /* continua a tentar */
      }
      if (attempts < 8) {
        timer = setTimeout(poll, 1500);
      } else {
        setState('failed');
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-sm p-10 text-center" data-testid="payment-return-card">
        {state === 'checking' && (
          <>
            <Loader2 className="w-12 h-12 text-[#BFA05F] animate-spin mx-auto" />
            <h1 className="font-heading text-2xl text-[#1A1815] mt-6">A confirmar o pagamento...</h1>
            <p className="text-sm text-[#635E54] mt-2">Aguarde um momento, por favor.</p>
          </>
        )}
        {state === 'success' && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-600 mx-auto" data-testid="payment-success-icon" />
            <h1 className="font-heading text-2xl text-[#1A1815] mt-6">Pagamento confirmado!</h1>
            <p className="text-sm text-[#635E54] mt-2">A sua marcação foi criada e paga com sucesso.</p>
            <Button
              data-testid="go-dashboard-btn"
              onClick={() => navigate('/dashboard')}
              className="mt-6 rounded-full bg-[#1A1815] text-white hover:bg-[#BFA05F] px-8 py-6"
            >
              Ver as minhas marcações
            </Button>
          </>
        )}
        {state === 'failed' && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" data-testid="payment-failed-icon" />
            <h1 className="font-heading text-2xl text-[#1A1815] mt-6">Pagamento não concluído</h1>
            <p className="text-sm text-[#635E54] mt-2">Não foi possível confirmar o pagamento. Tente novamente.</p>
            <Button
              onClick={() => navigate('/booking')}
              className="mt-6 rounded-full bg-[#1A1815] text-white hover:bg-[#BFA05F] px-8 py-6"
            >
              Voltar ao agendamento
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentReturnPage;
